enum AvatarColors {
  pastelBlue = 'bg-pastelBlue',
  lightCoral = 'bg-lightCoral',
  mauvelous = 'bg-mauvelous',
  rajah = 'bg-rajah',
  middleYellow = 'bg-middleYellow',
  buff = 'bg-buff',
  flavescent = 'bg-flavescent',
  middleGreen = 'bg-middleGreen',
  lightGreen = 'bg-lightGreen',
  etonBlue = 'bg-etonBlue',
  pearlAqua = 'bg-pearlAqua',
  cobaltBlue = 'bg-cobaltBlue',
  lightAzure = 'bg-lightAzure',
  winterWizard = 'bg-winterWizard',
  snowWizard = 'bg-snowWizard',
  brilliantLavender = 'bg-brilliantLavender',
  thistleCrayola = 'bg-thistleCrayola',
  brightUbe = 'bg-brightUbe',
  jordyBlue = 'bg-jordyBlue',
  bone = 'bg-bone',
  khaki = 'bg-khaki',
  pastelGrey = 'bg-pastelGrey',
}

export function getRandomColor(i: number) {
  const colors = Object.values(AvatarColors);

  return colors[i];
}
